export default "__VITE_ASSET__BuI6Lt3$__"